var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('aside', {
    staticClass: "_profile-data-column",
    class: {
      '_profile-data-column-yandex': _vm.mode === 'yandex-pay-success'
    }
  }, [_c('h5', {
    staticClass: "_profile-column-title"
  }, [_vm._v("Данные")]), _c('div', {
    staticClass: "_profile-hero-card"
  }, [_c('h4', {
    staticClass: "_profile-card-title"
  }, [_vm._v("Данные")]), _c('div', {
    staticClass: "_profile-info"
  }, [_c('div', {
    staticClass: "_profile-info-row"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/lk-phone.svg")
    }
  }), _c('p', [_vm._v(_vm._s(_vm.user.phone.formatted) + " ")])]), _c('div', {
    staticClass: "_profile-info-row"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/lk-letter.svg")
    }
  }), _c('p', [_vm._v(_vm._s(_vm.user.email))])])]), _vm._m(0)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-hero-imgs"
  }, [_c('img', {
    staticClass: "_profile-hero-imgs-side",
    attrs: {
      "src": require("@/assets/img/lk-hero-img-side.svg"),
      "alt": "imgs-side"
    }
  }), _c('img', {
    staticClass: "_profile-hero-imgs-center",
    attrs: {
      "src": require("@/assets/img/lk-hero-img-center.svg"),
      "alt": "imgs-center"
    }
  }), _c('img', {
    staticClass: "_profile-hero-imgs-side",
    attrs: {
      "src": require("@/assets/img/lk-hero-img-side.svg"),
      "alt": "imgs-side"
    }
  })]);
}]

export { render, staticRenderFns }